export default __webpack_public_path__ + "4765fa8d7f6b2083f7c53cf56890c8f5.png";